import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { UniversalNavigationContextProvider } from '@fff-web/fff-global-nav';
import { UserProvider } from '@fff-web/fff-utilities';
import App from './App';

globalThis.window.FFF = { ...globalThis.window.FFF };
globalThis.window.FFF[process.env.APP_NAME] = {
  version: process.env.APP_VERSION,
  libs: process.env.APP_LIBS,
};

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <UserProvider>
      <UniversalNavigationContextProvider>
        <App />
      </UniversalNavigationContextProvider>
    </UserProvider>
  </StrictMode>,
);
